import { ProviderConfigGroupCreator } from '@1js/search-types';
import { SearchConfig, SearchResources } from '../../search-results/services/search-config.service';
import { AppSuggestionProvider } from './app.search-suggestion-provider';
import { AppSearchSuggestionComponent } from './app.search-suggestion-renderer';
import { BingSearchSuggestionProvider } from './bing.search-suggestion-provider';
import { BingSearchSuggestionComponent } from './bing.search-suggestion-renderer';
import { FileSearchSuggestionProvider } from './file.search-suggestion-provider';
import { FileSearchSuggestionComponent } from './file.search-suggestion.renderer';
import { GoToSearchSuggestionProvider } from './goto.search-suggestion-provider';
import { GoToSearchSuggestionComponent } from './goto.search-suggestion-renderer';
import { HelpSearchSuggestionProvider } from './help.search-suggestion-provider';
import { HelpSearchSuggestionComponent } from './help.search-suggestion-renderer';
import { LearningSearchSuggestionProvider } from './learning.search-suggestion-provider';
import { LearningSearchSuggestionComponent } from './learning.search-suggestion-renderer';
import { SeeMoreSuggestionProvider } from './see.more-suggestion-provider';
import { SeeMoreSuggestionComponent } from './see.more-suggestion-renderer';
import { SerpSearchSuggestionProvider } from './serp.search-suggestion-provider';
import { SerpSearchSuggestionComponent } from './serp.search-suggestion-renderer';
import { SettingSearchSuggestionProvider } from './setting.search-suggestion-provider';
import { SettingSearchSuggestionComponent } from './setting.search-suggestion-renderer';
import { TemplatePreviewSuggestionProvider } from './template.preview-suggestion-provider';
import { TemplatePreviewSuggestionComponent } from './template.preview-suggestion-renderer';
import { TemplateSuggestionProvider } from './template.search-suggestion-provider';
import { TemplateSuggestionComponent } from './template.search-suggestion-renderer';

export function getSearchGroupCreators(config: SearchConfig, isMobileDevice: boolean): Array<ProviderConfigGroupCreator> {
    const resources: SearchResources = config.resources;
    const allProviders: Array<ProviderConfigGroupCreator> = [
        {
            groupId: 'serp',
            create() {
                return {
                    position: 11,
                    optimalCount: 1,
                    maxCount: 1,
                    providers: [SerpSearchSuggestionProvider],
                    component: SerpSearchSuggestionComponent,
                    heading: '',
                    ariaLabel: resources.SearchSuggestionSeeMoreHeading
                };
            }
        },
        {
            groupId: 'learning',
            create() {
                return {
                    position: 10,
                    optimalCount: 1,
                    maxCount: 1,
                    providers: [LearningSearchSuggestionProvider],
                    component: LearningSearchSuggestionComponent,
                    heading: '',
                    ariaLabel: resources.SearchSuggestionLearningAriaLabel
                };
            }
        },
        {
            groupId: 'seeMore',
            create() {
                return {
                    position: 9,
                    optimalCount: 1,
                    maxCount: 1,
                    providers: [SeeMoreSuggestionProvider],
                    component: SeeMoreSuggestionComponent,
                    heading: '',
                    ariaLabel: resources.SearchSuggestionOneDriveHeading
                };
            }
        },
        {
            groupId: 'bing',
            create() {
                return {
                    position: 8,
                    optimalCount: 1,
                    maxCount: 1,
                    providers: [BingSearchSuggestionProvider],
                    component: BingSearchSuggestionComponent,
                    heading: '',
                    ariaLabel: resources.SearchSuggestionBingHeading
                };
            }
        },
        {
            groupId: 'help',
            create() {
                return {
                    position: 7,
                    optimalCount: 2,
                    maxCount: 3,
                    providers: [HelpSearchSuggestionProvider],
                    component: HelpSearchSuggestionComponent,
                    heading: resources.SearchSuggestionHelpHeading,
                    ariaLabel: resources.SearchSuggestionHelpHeading
                };
            }
        },
        {
            groupId: 'templateNoPreview',
            create() {
                return {
                    position: 6,
                    optimalCount: 4,
                    maxCount: 4,
                    providers: [TemplatePreviewSuggestionProvider],
                    component: TemplatePreviewSuggestionComponent,
                    heading: resources.SearchSuggestionTemplateHeading,
                    ariaLabel: resources.SearchSuggestionTemplateHeading
                };
            }
        },
        {
            groupId: 'templatePreview',
            create() {
                return {
                    position: 6,
                    optimalCount: 4,
                    maxCount: 4,
                    providers: [TemplatePreviewSuggestionProvider],
                    component: TemplatePreviewSuggestionComponent,
                    heading: resources.SearchSuggestionTemplateHeading,
                    ariaLabel: resources.SearchSuggestionTemplateHeading
                };
            }
        },
        {
            groupId: 'setting',
            create() {
                return {
                    position: 5,
                    optimalCount: 1,
                    maxCount: 2,
                    providers: [SettingSearchSuggestionProvider],
                    component: SettingSearchSuggestionComponent,
                    heading: 'Settings',
                    ariaLabel: 'Settings'
                };
            }
        },
        {
            groupId: 'files',
            create() {
                return {
                    position: 4,
                    optimalCount: 3,
                    maxCount: 5,
                    providers: [FileSearchSuggestionProvider],
                    component: FileSearchSuggestionComponent,
                    heading: resources.SearchSuggestionFileHeading,
                    ariaLabel: resources.SearchSuggestionFileHeading
                };
            }
        },
        {
            groupId: 'template',
            create() {
                return {
                    position: 2,
                    optimalCount: 1,
                    maxCount: 3,
                    providers: [TemplateSuggestionProvider],
                    component: TemplateSuggestionComponent,
                    heading: resources.SearchSuggestionTemplateHeading,
                    ariaLabel: resources.SearchSuggestionTemplateHeading
                };
            }
        },
        {
            groupId: 'goTo',
            create() {
                return {
                    position: 1,
                    optimalCount: 2,
                    maxCount: 3,
                    providers: [GoToSearchSuggestionProvider],
                    component: GoToSearchSuggestionComponent,
                    heading: resources.SearchSuggestionGoToHeading,
                    ariaLabel: resources.SearchSuggestionGoToHeading
                };
            }
        },
        {
            groupId: 'apps',
            create() {
                return {
                    position: 0,
                    optimalCount: 2,
                    maxCount: 4,
                    providers: [AppSuggestionProvider],
                    component: AppSearchSuggestionComponent,
                    heading: resources.SearchSuggestionAppHeading,
                    ariaLabel: resources.SearchSuggestionAppHeading
                };
            }
        }
    ];

    const SearchGroupCreators: Array<ProviderConfigGroupCreator> = [];

    allProviders.forEach( provider => {
        switch (provider.groupId) {
            case 'goTo':
                if (config.goToProviderEnabled) {
                    SearchGroupCreators.push(provider);
                }
                break;
            case 'setting':
                if (config.settingProviderEnabled) {
                    SearchGroupCreators.push(provider);
                }
                break;
            case 'template':
                if (isMobileDevice || !(config.templatePreviewProviderWithSeeMoreEnabled || config.templatePreviewProviderWithNoThumbnails)) {
                    SearchGroupCreators.push(provider);
                }
                break;
            case 'templatePreview':
                if (!isMobileDevice && config.templatePreviewProviderWithSeeMoreEnabled) {
                    SearchGroupCreators.push(provider);
                }
                break;
            case 'learning':
                if (config.learningProviderEnabled && !isMobileDevice && config.templatePreviewProviderWithSeeMoreEnabled) {
                    SearchGroupCreators.push(provider);
                }
                break;
            case 'templateNoPreview':
                if (!isMobileDevice && config.templatePreviewProviderWithNoThumbnails) {
                    SearchGroupCreators.push(provider);
                }
                break;
            case 'serp':
                if (!isMobileDevice && !config.disableSearchEnterPressedAction) {
                    SearchGroupCreators.push(provider);
                }
                break;
            default:
                SearchGroupCreators.push(provider);
        }
    });

    return SearchGroupCreators;
}
